import { render, staticRenderFns } from "./Dependencia.vue?vue&type=template&id=4ef7e1f8&"
import script from "./Dependencia.vue?vue&type=script&lang=js&"
export * from "./Dependencia.vue?vue&type=script&lang=js&"
import style0 from "./Dependencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports